import React, {useState} from "react";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {FileForm} from "../forms";
import {documentService} from "../../services";
import {forms} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";

const toData = (file) => {
    return {
        fileName: file.fileName,
        order: file.order,
        ranks: file.ranks,
        valid: sortingUtils.isSortable(file.order),
    }
};

const EditFileDialog = (props) => {
    const { snackbar, file, onCancel, onSave } = props;
    const [ data, setData ] = useState(toData(file));
    const [ saving, setSaving ] = useState(false);

    const submitForm = () => {
        setSaving(true);

        const success = (saved) => {
            snackbar.setSuccess(saved.fileName + " saved");
            setSaving(false);
            onSave(saved);
        };

        const failure = (err) => {
            snackbar.setError(err);
            setSaving(false);
        };

        const modified = {
            fileName: data.fileName,
            ranks: data.ranks,
            order: data.order,
        };

        documentService.saveFile(file.id, modified, success, failure);
    }

    return <Dialog
        open={true}
        aria-labelledby="edit-file-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            Edit File
        </ClosableDialogTitle>
        <DialogContent className="edit-file-dialog">
            {saving ?
                <CircularProgress size="40px"/> :
                <FileForm
                    data={data}
                    onChange={setData}
                />}
        </DialogContent>
        {!saving ? <DialogActions>
            <Button color="primary"
                    disabled={!data.valid || !forms.differ(toData(file), data)}
                    onClick={submitForm}>
                Save
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default EditFileDialog;
